export default __webpack_public_path__ + "static/media/close-button-filled.c64d913c.svg";